import type { FaireThemeEntity } from "../../entity_types/theme";

export const cz_sparkle_and_glam_accents: FaireThemeEntity = {
  token: "cz-sparkle-and-glam-accents",
  type: "theme",
  name: "CZ Sparkle & Glam Accents",
  description: "Add some brilliance to your checkout counter with cubic zirconia-studded necklaces and earrings that provide a high-end look at an accessible price.",
  teaser: "K&K Visage Beauty Lounge is well-positioned to offer impulse-buy 'glam' items that complement beauty services. These cubic zirconia pieces offer the 'Bright & Bold' style your store frequently explores.",
  detail: "The additional context highlights a specific interest in the Novaé Earring Set and Éclaire Necklace, both of which feature cubic zirconia and are tagged with 'Glam' and 'Romantic' styles.",
  bgColor: "#C4D4B0",
  tileBgColor: "#39676b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_z2pqfx2mwn",
    "p_8hh7y84r3b",
    "p_s39yqbk8sz",
    "p_pa6vrey3pp",
    "p_5vabm4zrzc",
    "p_nddbma222u",
    "p_v2uh6vz75s",
    "p_9de3mat7p2",
    "p_5gefr7p29d",
    "p_g7k8ya2wbv",
    "p_827myhbz4e",
    "p_gbnp9dbmch",
    "p_4aedre7acc",
    "p_hnmdt9abm6",
    "p_pqf2f49nzz",
    "p_pp7h5p8925",
    "p_f9c6b9pvwy",
    "p_598gfwvh32",
    "p_zsrzgkqrpx",
    "p_vndrc5e385",
    "p_85zuvdfqvw",
    "p_j29gzkwfeh",
    "p_gjqrgvgkbd",
    "p_hr2c2qxn5f",
    "p_67r23q3gye",
    "p_e4q97m9fhd",
    "p_wjz67mpm5w",
    "p_cmzrmk6q6r",
    "p_s7mxah3gtv",
    "p_m8c65uwxfq",
    "p_qtp8z4httd",
    "p_w86su3d6cx",
    "p_ar6ja253qt",
    "p_qwdqk3ppdj",
    "p_m4uahrzh7m",
    "p_3423cjusrh",
    "p_dvc55z5255",
    "p_v6c88h69zr",
    "p_ut3tbs6mrw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
